































import { collections } from "@/configs/firebase";
import { Vue, Component } from "vue-property-decorator";
import moment from "moment";

@Component
export default class Nominations extends Vue {
  nominations: any[] = [];

  async mounted() {
    const snapshot = await collections.doctorNominations
      .where("submitted", "==", false)
      .get();
    this.nominations = snapshot.docs.map(doc => ({
      ...doc.data(),
      id: doc.id
    }));
  }

  async check(selection: any) {
    await collections.doctorNominations
      .doc(selection.id)
      .update({ submitted: true });
  }

  formatTime(ts: number) {
    return moment.unix(ts).fromNow();
  }
}
